import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=3caa54da&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3caa54da')) {
      api.createRecord('3caa54da', component.options)
    } else {
      api.reload('3caa54da', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=3caa54da&", function () {
      api.rerender('3caa54da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qtxRESTzOewW/JS/comp/CurrentYear.vue"
export default component.exports